import { Routes } from '@angular/router';
import { NavViewComponent } from '@app/features/nav-view/pages/nav-view.component';
import { deviceRoutes } from '@app/features/device-health/device.routing';
import { locationRoutes } from '@app/features/locations/modules/location/location.routing';
import { chainWideMerakisRoutes } from '@app/features/merakis/modules/chain-wide-merakis/chain-wide-merakis.routing';
import { chainWideCradlepointsRoutes } from '@app/features/cradlepoints/modules/chain-wide-cradlepoints/chain-wide-cradlepoints.routing';
import { chainWideFortigatesRoutes } from '@app/features/fortigates/modules/chain-wide-fortigates/chain-wide-fortigates.routing';
import { chainWideMistsRoutes } from '@app/features/mists/modules/chain-wide-mists/chain-wide-mists.routing';
import { chainHealthRoutes } from '@app/features/chain-health/modules/chain-health/chain-health.routing';
import { wanRoutes } from '@app/features/wan/modules/wan-health/wan-health.routing';
import { lanRoutes } from '@app/features/lan/modules/lan-health/lan-health.routing';
import { wifiRoutes } from '@app/features/wifi/modules/wifi-health/wifi-health.routing';
import { datadogRoutes } from '@app/features/datadog/modules/datadog-dashboard/datadog-dashboard.routing';
import { lumenDiagnisticRoutes } from '@app/features/lumen-diagnostics/lumen-diagnostics.routing';
import { fortinetMetricsRoutes } from '../fortinet-metrics/fortinet-metrics.routing';
import { locationClosuresRoutes } from '@app/features/locations/components/location-closures/location-closures.routing';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { availabilityRoutes } from '../metrics/modules/availability/availability.routing';
import { CpSpeedTestsRoutes } from '../metrics/modules/cp-speed-tests/cp-speed-tests.routing';
import { circuitMapRoutes } from '../circuit-map/circuit-map.routing';
import { kevlar2ProgressRoutes } from '../metrics/modules/kevlar2-progress/kevlar2-progress.routing';

export const navViewRoutes: Routes = [
    {
        path: 'health',
        children: [
            {
                path: '',
                component: NavViewComponent,
                data: {
                    authorities: ['ADMIN', 'HELP_1', 'LOGIN', 'UPDATE']
                },
                canActivate: [RouteAccessGuard]
            },
            ...deviceRoutes,
    ...locationRoutes,
    ...chainWideMerakisRoutes,
    ...chainWideCradlepointsRoutes,
    ...chainWideFortigatesRoutes,
    ...chainWideMistsRoutes,
    ...chainHealthRoutes,
    ...wanRoutes,
    ...lanRoutes,
    ...wifiRoutes,
    ...datadogRoutes,
    ...locationClosuresRoutes,
    ...lumenDiagnisticRoutes,
    ...fortinetMetricsRoutes,
    ...availabilityRoutes,
    ...CpSpeedTestsRoutes,
            ...circuitMapRoutes,
            ...kevlar2ProgressRoutes
        ]
    }
]